import { DatosPersonalesProspecto } from './datos-personales-prospecto.class';
export class RegistroProspecto {
    dni: String;
    codigoAsesor: String;
    datosPersonales: DatosPersonalesProspecto;
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/prospecto/registro-prospecto.class.ts